import classNames from "classnames";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { TextButton } from "../../../../textButton/textButton";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { useStore } from "../../../../../models";
import settingsStyles from "../../../../../styles/settings.css";
import { AdviserPicker } from "../../../../forms/adviserPicker/adviserPicker";

interface Props {
  adviserIds: string[];
  onPicked(adviserId: string): void;
  initialIsOpen?: boolean;
  hasError?: boolean;
  ListComponent: JSX.Element | undefined;
}

export const AdvisersInput = observer(
  ({ adviserIds, onPicked, ListComponent, initialIsOpen, hasError }: Props) => {
    const { agentStore } = useStore();
    const [isPicking, setIsPicking] = useState(initialIsOpen);
    const pickableAdvisers = agentStore.getWithoutIds(adviserIds);

    const renderInput = () =>
      isPicking ? (
        <AdviserPicker
          className={classNames(
            !!ListComponent && settingsStyles["list-margin"],
            settingsStyles["input-width-bigger"]
          )}
          onChange={(adviser) => {
            onPicked(adviser.id);
            setIsPicking(false);
          }}
          values={pickableAdvisers}
          hasError={hasError}
          initialIsOpen={!!adviserIds.length}
          onOutsideClick={() => setIsPicking(!ListComponent)}
          onStateChange={
            initialIsOpen
              ? undefined
              : (_, state) => (!state.isOpen ? setIsPicking(false) : undefined)
          }
        />
      ) : (
        <TextButton
          text={"+ " + intl.formatMessage("settings.adviserGroups.form.advisers.add")}
          className={settingsStyles["list-margin"]}
          onClick={() => setIsPicking(true)}
        />
      );

    return (
      <div>
        {ListComponent}
        {!!pickableAdvisers.length && renderInput()}
      </div>
    );
  }
);
